export default __webpack_public_path__ + "static/europe-results-1-040b4b37f573826aa14876c92f99dfde.png";